import { render } from "./ProjectHall.vue?vue&type=template&id=7de06d5b&ts=true"
import script from "./ProjectHall.vue?vue&type=script&lang=ts"
export * from "./ProjectHall.vue?vue&type=script&lang=ts"

import "./ProjectHall.vue?vue&type=style&index=0&id=7de06d5b&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__